import React, { useState, useEffect } from "react";
import crypto from "crypto";

import Modal from "react-bootstrap/Modal";
import { InputGroup } from "react-bootstrap";

import moment from "moment";

import * as Constant from "../../../Constant.js";
import axios from "@app/lib/axios";
import * as commonData from "@app/lib/common_data";

import AccountList from "./AccountList.js";

import ChangeBizApp from "./Component/ChangeBizApp.js";
import ChangeBizRep from "./Component/ChangeBizRep.js";

const Update = ({ id }) => {
	const [serviceAppList, setServiceAppList] = useState(null);
    const [data, setData] = useState(null);
    const [locCode, setLocCode] = useState(null);

    useEffect(() => {
        if (!serviceAppList) {
            commonData.getServiceAppList(axios, (err, list) => {
                if (!err) {
                    setServiceAppList(list);
                }
            });
        }
        return () => {};
    }, [id]);

    useEffect(() => {
        if(serviceAppList) getInfo();
        return () => {};
    }, [serviceAppList]);

    const getInfo = () => {
        if (data) setData(null);
        axios({
            method: "get",
            url: `${Constant.API_DOMAIN}/api/branch/${id}`,
        })
            .then((res) => {
				console.log(res)
                const _data = {
                    branch: res.data.branch,
                    bizApp: res.data.bizApp,
                    accounts: res.data.account,
                    bank_code: res.data.bank_code,
					bizRepList: res.data.bizRepList
                };
                const attach = {};
                res.data.attach.forEach((a) => {
                    attach[a.type] = a;
                });
                _data.attach = attach;

                _data.branch.ceo_num = _data.branch.ceo_num ? Buffer.from(_data.branch.ceo_num, "base64").toString("utf8") : "";

                let result = [];
				if(_data.bizApp && _data.bizApp.length > 0) {
					serviceAppList.forEach((sa) => {
						const serviceApp = _data.bizApp.find((a) => sa.key == a);
						if(serviceApp) {
							result.push(sa.name);
						}
					});
				}
                _data.bizAppKor = result;
                setData(_data);
                if (!locCode) getLocCodes(_data);
            })
            .catch((error) => {
                console.log(error);
                setData(null);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    const getLocCodes = (_data) => {
		commonData.getLocCodes(axios, (err, result) => {
			if(!err) {
                const _locCode = {
                    sidoList: result,
                };
                if (result.length > 0 && _data) {
                    const branch = { ..._data.branch };

                    let ceo_sigunguList = null;
                    if (branch.ceo_address_parent_code) {
                        const filter = result.filter((s) => s.code == branch.ceo_address_parent_code);
                        ceo_sigunguList = filter.length > 0 ? filter[0].child : null;
                    } else {
                        ceo_sigunguList = result[0].child;
                    }
                    _locCode.ceo_sigunguList = ceo_sigunguList;

                    let cntnts_sigunguList = null;
                    if (branch.cntnts_address_parent_code) {
                        const filter = result.filter((s) => s.code == branch.cntnts_address_parent_code);
                        cntnts_sigunguList = filter.length > 0 ? filter[0].child : null;
                    } else {
                        cntnts_sigunguList = result[0].child;
                    }
                    _locCode.cntnts_sigunguList = cntnts_sigunguList;

                    setLocCode(_locCode);
                }
			}
		});
    };

    const changeHandler = (e) => {
        const { name, value } = e.target;
        const _data = { ...data };
        _data.branch[name] = value;
        setData(_data);
    };

    const fileHandler = (type, e) => {
        const { files } = e.target;
        const file = files[0];

        if (file) {
            if (file.size > 5242880) {
                alert("파일 사이즈는 5Mb 이하만 업로드 가능합니다.");
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                const _data = { ...data };
                _data.attach[type] = {
                    type: type,
                    file_name: file.name,
                    file_data: Buffer.from(reader.result).toString("base64"),
                    is_new: true,
                };
                console.log(`${file.name} size : ${file.size / 1024}kb -> ${_data.attach[type].file_data.length / 1024}kb`);
                setData(_data);
            };
            reader.readAsDataURL(file);
        }
    };

    const onChangeSido = (type, e) => {
        const _locCode = { ...locCode };
        const { name, value } = e.target;
        let sidoFilter = null;
        if (_locCode) {
            sidoFilter = _locCode.sidoList.filter((s) => s.code == value);
            const child = sidoFilter.length > 0 ? sidoFilter[0].child : _locCode.sidoList[0].child;
            _locCode[type + "_sigunguList"] = child;
            const _data = { ...data };
            _data.branch[name] = value;
            _data.branch[type + "_address_code"] = child[0].code;
            setData(_data);
            setLocCode(_locCode);
        }
    };

    const deleteAttach = (type) => {
        if (window.confirm("파일을 삭제 하시겠습니까?")) {
            const _data = { ...data };
            if (_data.attach[type]) {
                _data.attach[type].file_data = "";
                _data.attach[type].file_name = "";
                setData(_data);
            }
        }
    };

    const fieldRequired = [
        { key: "name", name: "지사명" },
        { key: "mobile", name: "지사장 휴대전화" },
        { key: "email", name: "지사 이메일" },
        { key: "address", name: "지사 주소" },
        { key: "tel", name: "지사 유선전화" },
    ];
    const submitData = () => {
        const _data = { ...data };
        const invalidArr = [];
        Object.keys(_data.branch).forEach((k) => {
            if (!_data.branch[k]) {
                const required = fieldRequired.find((f) => f.key == k);
                if (required) {
                    invalidArr.push(required);
                } else {
                    _data.branch[k] = "";
                }
            }
            if (k.indexOf("_address_code") >= 0) {
                _data.branch[k] = document.getElementsByName(k)[0].value;
            }
            if (k === "ceo_num") {
                _data.branch[k] = Buffer.from(_data.branch[k]).toString("base64");
            } else if (k === "bank" && !_data.branch[k]) {
                _data.branch[k] = data.bank_code[0].code;
            }
        });
        if (invalidArr.length > 0) {
            alert("입력 되지 않은 항목이 존재합니다.\n" + invalidArr.map((i) => i.name).join(", "));
            return;
        }

        const attachArr = [];
        Object.keys(_data.attach).forEach((type) => {
            attachArr.push(_data.attach[type]);
        });

        axios({
            method: "patch",
            url: `${Constant.API_DOMAIN}/api/branch/${id}`,
            data: {
                branch: _data.branch,
                attach: attachArr,
                bizApp: _data.bizApp,
            },
        })
            .then((res) => {
                alert("저장 되었습니다.");
                window.location.reload();
            })
            .catch((error) => {
                console.log(error);
                setData(null);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    if (!data) {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-ecommerce">
                    <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                        <div className="row">
                            <div className="col-xl-2 col-lg-2 col-md-3 col-sm-12 col-12">
                                <div className="page-header">
                                    <h2 className="pageheader-title">
                                        <span className="fa fa-spinner" />
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-wrapper">
            <div className="dashboard-ecommerce">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12 col-12">
                            <div className="page-header">
                                <h2 className="pageheader-title">{data.branch.name}</h2>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-12 col-12">
                            <label className="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="status" value="join" checked={data.branch.status == "join"} className="custom-control-input" onChange={changeHandler} />
                                <span className="custom-control-label">계약</span>
                            </label>

                            <label className="custom-control custom-radio custom-control-inline">
                                <input type="radio" name="status" value="terminate" checked={data.branch.status == "terminate"} className="custom-control-input" onChange={changeHandler} />
                                <span className="custom-control-label">해지</span>
                            </label>
                        </div>
                    </div>
                </div>

                <div className="container-fluid dashboard-content pb-2">
                    <div className="row">
                        <div className="col-xl-5 col-lg-5 col-md-12 col-sm-12 col-12 mb-3">
                            <div className="page-header mb-2">
                                <h5 className="pageheader-title text-muted">지사 정보</h5>
                            </div>
                    		<table className="table table-bordered bg-light">
					            <colgroup>
					                <col style={{minWidth: '150px', width: '20%'}}/>
					                <col />
					            </colgroup>
					            <tr>
					                <th className="bg-dark text-light">지사 코드(ID)</th>
					                <td>
					                    <span className="mt-2 text-danger">{data.branch.code}</span>
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사명</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="name" type="text" maxLength={64} value={data.branch.name} onChange={changeHandler} placeholder="지사명" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사장 명</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="rep" type="text" maxLength={64} value={data.branch.rep} onChange={changeHandler} placeholder="지사장 명" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사장 휴대전화</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="mobile" type="text" maxLength={20} value={data.branch.mobile} onChange={changeHandler} placeholder="지사장 휴대전화" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사 유선전화</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="tel" type="text" maxLength={20} value={data.branch.tel} onChange={changeHandler} placeholder="지사 유선전화" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사 팩스</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="fax" type="text" maxLength={20} value={data.branch.fax} onChange={changeHandler} placeholder="지사 팩스" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사 이메일</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="email" type="text" maxLength={2320} value={data.branch.email} onChange={changeHandler} placeholder="지사 이메일" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">지사 주소</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="address" type="text" maxLength={128} value={data.branch.address} onChange={changeHandler} placeholder="지사 주소" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">계약 권한</th>
					                <td>
					                    <span className="mt-2 text-primary">{data.bizAppKor.join(', ')}</span>
					                    <ChangeBizApp
                                            serviceAppList={serviceAppList}
                                            bizApp={data.bizApp}
                                            callback={(apps) => {
                                                const _data = { ...data };
                                                _data.bizApp = apps;
                                                let result = [];
                                                if(_data.bizApp && _data.bizApp.length > 0) {
                                                    serviceAppList.forEach((sa) => {
                                                        const serviceApp = _data.bizApp.find((a) => sa.key == a);
                                                        if(serviceApp) {
                                                            result.push(sa.name);
                                                        }
                                                    });
                                                }
                                                _data.bizAppKor = result;
                                                setData(_data);
                                            }}
					                    />
					                </td>
					            </tr>
								<tr>
					                <th className="bg-dark text-light">영업 담당자</th>
					                <td>
									<span className="mt-2 text-primary">{data.branch.biz_rep}</span>
										<ChangeBizRep
											bizRepList={data.bizRepList}
                                            bizRep={data.branch.biz_rep}
                                            callback={(bizRep) => {
												console.log(bizRep)
                                                const _data = { ...data };
												_data.branch.biz_rep = bizRep;
												setData(_data)
                                            }}
					                    />
					                </td>
					            </tr>
							</table>
							<table className="table table-bordered bg-light mt-5">
					            <colgroup>
					                <col style={{minWidth: '150px', width: '20%'}}/>
					                <col />
					            </colgroup>
					            <tr>
					                <th colSpan="2" className="bg-dark text-light">정산 관련 정보</th>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">담당자 명</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cal_charger" type="text" maxLength={20} value={data.branch.cal_charger} onChange={changeHandler} placeholder="정산 담당자명" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">담당자 휴대전화</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cal_charger_mobile" type="text" maxLength={20} value={data.branch.cal_charger_mobile} onChange={changeHandler} placeholder="정산 담당자 휴대전화" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">담당자 이메일</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cal_charger_email" type="text" maxLength={100} value={data.branch.cal_charger_email} onChange={changeHandler} placeholder="정산 담당자 이메일" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">거래처 코드</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="ec_account_code" type="text" maxLength={100} value={data.branch.ec_account_code} onChange={changeHandler} placeholder="이카운트 거래처 코드" />
					                </td>
					            </tr>
					        </table>
                    	</div>


						<div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12">
							<div className="page-header mb-2">
                                <h5 className="pageheader-title text-muted">
                                	지사 사업자 정보
                                </h5>
                            </div>
                    		<table className="table table-bordered bg-light">
                    			<colgroup>
					                <col style={{minWidth: '150px', width: '20%'}}/>
					                <col />
					            </colgroup>
					            <tr>
					                <th className="bg-dark text-light">사업자등록 상호</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cntnts_name" type="text" maxLength={45} value={data.branch.cntnts_name} onChange={changeHandler} placeholder="사업자등록 상호" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자등록 번호</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cntnts_num" type="text" maxLength={15} value={data.branch.cntnts_num} onChange={changeHandler} placeholder="사업자등록 번호" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자 대표명</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="ceo" type="text" value={data.branch.ceo} onChange={changeHandler} placeholder="사업자 대표명" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자 대표 주민번호</th>
					                <td>
					                    <input
					                    	className="form-control placeholder-clear-on-focus"
					                    	name="ceo_num"
					                    	type="text"
					                    	value={data.branch.ceo_num}
					                    	onChange={changeHandler}
					                    	maxLength="17"
					                    	placeholder="사업자 대표 주민번호"
					                    />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자 대표 휴대전화</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="ceo_tel" type="text" maxLength={20} value={data.branch.ceo_tel} onChange={changeHandler} placeholder="사업자 대표 휴대전화" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">거래처 업태</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cntnts_type" type="text" maxLength={50} value={data.branch.cntnts_type} onChange={changeHandler} placeholder="거래처 업태" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">거래처 종목</th>
					                <td>
					                    <input className="form-control placeholder-clear-on-focus" name="cntnts_item" type="text" maxLength={45} value={data.branch.cntnts_item} onChange={changeHandler} placeholder="거래처 종목" />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업장 주소</th>
					                <td>
					                	<InputGroup className="input-group my-group">
					                        <InputGroup.Prepend className="input-group-append">
					                            <InputGroup.Text style={{width:"50px", justifyContent:"center", height: '38px'}}>시/도</InputGroup.Text>
					                        </InputGroup.Prepend>
					                        <select
					                            className="form-control  input-group-append"
					                            onChange={(e) => onChangeSido('cntnts', e)}
												name="cntnts_address_parent_code"
					                            value={data.branch.cntnts_address_parent_code}
					                        >
					                            {(locCode && locCode.sidoList) && (
					                                locCode.sidoList.map((sido) => {
					                                    return (<option value={sido.code}>{sido.name}</option>);
					                                })
					                            )}
					                        </select>
					                        <InputGroup.Append>
					                            <InputGroup.Text style={{width:"80px", justifyContent:"center", height: '38px'}}>시/군/구</InputGroup.Text>
					                        </InputGroup.Append>
					                        <select
					                            className="form-control placeholder-clear-on-focus  input-group-append"
					                            name="cntnts_address_code"
					                            value={data.branch.cntnts_address_code}
					                            onChange={changeHandler}
					                        >
					                            {(locCode && locCode.cntnts_sigunguList) && (
					                                locCode.cntnts_sigunguList.map((sigungu) => {
					                                    return (<option value={sigungu.code} eng_name={sigungu.eng_min_name}>{sigungu.name}</option>);
					                                })
					                            )}
					                        </select>
					                    </InputGroup>
					                    <InputGroup className="input-group my-group mt-1">
					                        <InputGroup.Prepend className="input-group-append">
					                            <InputGroup.Text style={{width:"100px", justifyContent:"center"}}>상세주소</InputGroup.Text>
					                        </InputGroup.Prepend>
					                        <input
					                            className="form-control placeholder-clear-on-focus input-group-append"
					                            type="text"
					                            name="cntnts_address"
					                            value={data.branch.cntnts_address}
					                            placeholder="시/도, 시/군/구를 제외한 상세주소를 입력해주세요"
					                            onChange={changeHandler}
					                        />
					                    </InputGroup>
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자 대표 거주 주소</th>
					                <td>
					                	<InputGroup className="input-group my-group">
					                        <InputGroup.Prepend className="input-group-append">
					                            <InputGroup.Text style={{width:"50px", justifyContent:"center", height: '38px'}}>시/도</InputGroup.Text>
					                        </InputGroup.Prepend>
					                        <select
					                            className="form-control  input-group-append"
					                            onChange={(e) => onChangeSido('ceo', e)}
												name="ceo_address_parent_code"
					                            value={data.branch.ceo_address_parent_code}
					                        >
					                            { (locCode && locCode.sidoList) && (
					                                locCode.sidoList.map((sido) => {
					                                    return (<option value={sido.code}>{sido.name}</option>);
					                                })
					                            )}
					                        </select>
					                        <InputGroup.Append>
					                            <InputGroup.Text style={{width:"80px", justifyContent:"center", height: '38px'}}>시/군/구</InputGroup.Text>
					                        </InputGroup.Append>
					                        <select
					                            className="form-control  input-group-append"
					                            name="ceo_address_code"
					                            value={data.branch.ceo_address_code}
					                            onChange={changeHandler}
					                        >
					                            {locCode && locCode.ceo_sigunguList && (
					                                locCode.ceo_sigunguList.map((sigungu) => {
					                                    return (<option value={sigungu.code} eng_name={sigungu.eng_min_name}>{sigungu.name}</option>);
					                                })
					                            )}
					                        </select>
					                    </InputGroup>
					                    <InputGroup className="input-group my-group mt-1">
					                        <InputGroup.Prepend className="input-group-append">
					                            <InputGroup.Text style={{width:"100px", justifyContent:"center"}}>상세주소</InputGroup.Text>
					                        </InputGroup.Prepend>
					                        <input
					                            className="form-control placeholder-clear-on-focus input-group-append"
					                            type="text"
					                            name="ceo_address"
					                            value={data.branch.ceo_address}
					                            placeholder="시/도, 시/군/구를 제외한 상세주소를 입력해주세요"
					                            onChange={changeHandler}
					                        />
					                    </InputGroup>
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자 가상 계좌 정보</th>
					                <td>
					                	<InputGroup className="input-group my-group">
											<select
												className="form-control placeholder-clear-on-focus input-group-append"
												name="bank"
												style={{ height: "auto", maxWidth:"100px" }}
												value={data.branch.bank}
												onChange={changeHandler}
											>
												{data && data.bank_code && (
													data.bank_code.map(b => {
														return <option value={b.code}>{b.name}</option>
													})
												)}
											</select>
			                                <input
			                                    className="form-control placeholder-clear-on-focus"
			                                    type="text"
			                                    name="bank_account"
			                                    placeholder="계좌번호"
			                                    value={data.branch.bank_account}
			                                    onChange={changeHandler} 
			                                />
			                            </InputGroup>
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자등록증</th>
					                <td>
					                    {data.attach.C && data.attach.C.file_data && (
					                    	<>
					                    		<span className="mt-2">{data.attach.C.file_name}</span>
												<span
													className="ml-2 pt-1 fas fa-minus-circle text-danger" 
													style={{cursor: 'pointer'}}
													onClick={() => {
														deleteAttach('C');
													}}
												/>
					                    		<ImageModal
					                    			type='C'
					                    			file_name={data.attach.C.file_name}
					                    			file_data={data.attach.C.file_data}
					                    		/>
					                    	</>
					                    )}
					                    <button
					                    	className="float-right btn btn-sm btn-outline-success font-12"
					                    	onClick={() => {
					                    		document.getElementById('attach_c').click();
					                    	}}
					                    >
					                    	첨부
					                    </button>
					                    <input
					                    	type="file"
					                    	id="attach_c"
					                    	name="attach_c"
					                    	style={{display: 'none'}}
					                    	onChange={(e) => fileHandler('C', e)} 
					                    	accept="image/png, image/jpeg, image/jpg"
					                    />
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">대표 주민등록증</th>
					                <td>
					                    {data.attach.J && data.attach.J.file_data && (
					                    	<>
					                    		<span className="mt-2">{data.attach.J.file_name}</span>
												<span
													className="ml-2 pt-1 fas fa-minus-circle text-danger" 
													style={{cursor: 'pointer'}}
													onClick={() => {
														deleteAttach('J');
													}}
												/>
					                    		<ImageModal
					                    			type='J'
					                    			file_name={data.attach.J.file_name}
					                    			file_data={data.attach.J.file_data}
					                    		/>
					                    	</>
					                    )}
					                    <button
					                    	className="float-right btn btn-sm btn-outline-success font-12"
					                    	onClick={() => {
					                    		document.getElementById('attach_j').click();
					                    	}}
					                    >
					                    	첨부
					                    </button>
					                    <input
					                    	type="file"
					                    	id="attach_j"
					                    	name="attach_j"
					                    	style={{display: 'none'}}
					                    	onChange={(e) => fileHandler('J', e)}
					                    	accept="image/png, image/jpeg, image/jpg"
					                   	/>
					                </td>
					            </tr>
					            <tr>
					                <th className="bg-dark text-light">사업자 통장사본</th>
					                <td>
					                    {data.attach.B && data.attach.B.file_data && (
					                    	<>
					                    		<span className="mt-2">{data.attach.B.file_name}</span>
												<span
													className="ml-2 pt-1 fas fa-minus-circle text-danger" 
													style={{cursor: 'pointer'}}
													onClick={() => {
														deleteAttach('B');
													}}
												/>
					                    		<ImageModal
					                    			type='B'
					                    			file_name={data.attach.B.file_name}
					                    			file_data={data.attach.B.file_data}
					                    		/>
					                    	</>
					                    )}
					                    <button
					                    	className="float-right btn btn-sm btn-outline-success font-12"
					                    	onClick={() => {
					                    		document.getElementById('attach_b').click();
					                    	}}
					                    >
					                    	첨부
					                    </button>
					                    <input
					                    	type="file"
					                    	id="attach_b"
					                    	name="attach_b"
					                    	style={{display: 'none'}}
					                    	onChange={(e) => fileHandler('B', e)}
					                    	accept="image/png, image/jpeg, image/jpg"
					                    />
					                </td>
					            </tr>
                    		</table>
                    	</div>
                    </div>

                    <AccountList type="admin" serviceAppList={serviceAppList} branch={data ? data.branch : null} bizApp={data ? data.bizApp : null} account={data.accounts} reloadAccount={getInfo} />

                    <div className="row mt-3">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <button className="btn btn-primary btn-rounded">지사 삭제</button>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-right">
                            <button className="btn btn-warning btn-rounded mr-2" onClick={submitData}>
                                저장
                            </button>
                            <button className="btn btn-dark btn-rounded" onClick={() => (document.location.href = "./branch")}>
                                목록
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ImageModal = ({ type, file_name, file_data }) => {
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState("");

    useEffect(() => {
        let title = "사업자등록증";
        switch (type) {
            case "C":
                title = "사업자등록증";
                break;
            case "J":
                title = "대표 주민등록증";
                break;
            case "B":
                title = "사업자 통장사본";
                break;
        }
        setTitle(title);
        return () => {};
    }, [type, file_name, file_data]);

    return (
        <>
            <button className="float-right btn btn-sm btn-info ml-3 font-12" onClick={() => setShow(true)}>
                보기
            </button>
            <Modal size="lg" show={show} onHide={() => setShow(false)} aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ overflow: "auto" }}>{file_data && <img src={Buffer.from(file_data, "base64").toString("utf8")} alt={file_name} style={{ width: "100%" }} />}</Modal.Body>
            </Modal>
        </>
    );
};

export default Update;